import * as React from "react";

const NISpdf: React.FC = () => {
    return (
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 0C1.62109 0 0.5 1.12109 0.5 2.5V17.5C0.5 18.8789 1.62109 20 3 20H13C14.3789 20 15.5 18.8789 15.5 17.5V6.25H10.5C9.80859 6.25 9.25 5.69141 9.25 5V0H3ZM10.5 0V5H15.5L10.5 0ZM4.875 10H11.125C11.4688 10 11.75 10.2812 11.75 10.625C11.75 10.9688 11.4688 11.25 11.125 11.25H4.875C4.53125 11.25 4.25 10.9688 4.25 10.625C4.25 10.2812 4.53125 10 4.875 10ZM4.875 12.5H11.125C11.4688 12.5 11.75 12.7812 11.75 13.125C11.75 13.4688 11.4688 13.75 11.125 13.75H4.875C4.53125 13.75 4.25 13.4688 4.25 13.125C4.25 12.7812 4.53125 12.5 4.875 12.5ZM4.875 15H11.125C11.4688 15 11.75 15.2812 11.75 15.625C11.75 15.9688 11.4688 16.25 11.125 16.25H4.875C4.53125 16.25 4.25 15.9688 4.25 15.625C4.25 15.2812 4.53125 15 4.875 15Z"
                fill="#2B5197"
            />
        </svg>
    );
};

export default React.memo(NISpdf);
